import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import SecondLoader from "../SecondLoader";
import AddEmergencyContactSchema from "../../utils/SchemasValidation/AddEmergencyContactSchema";
import ValidateSchema from "../../helpers/ValidateSchema";
// import classes from "../../assets/styles/CustomURLModal.module.css";
import { MdClose } from "react-icons/md";
import FormInput from "../../components/Forms/FormInput";
import PhoneInput from "react-phone-input-2";
import ImageUpload from "../../components/ImageUpload";
import pictureicon from "../../assets/images/function_page_icons/picIcon.svg";
import contacticon from "../../assets/images/function_page_icons/contacticon.svg";
import _ from "lodash";
import { validatePhoneWithCountryCode } from "../../utils/functions";
import showToast from "../../helpers/showToast";
import { EMERGENCY_CONTACT_VCF_FILE_URL } from "../../utils/constants/apiUrl";
import { post } from "../../server";
import { loggedInUser } from "../../utils/store";
import { useAtom } from "jotai";
import { trackEvent } from "../../utils/mixpanel";
import { useLocation } from "react-router-dom";
import { Form } from "react-bootstrap";

const EmergencyAddEditModal = ({
  loading,
  data,
  setSelectedData,
  handleSaveShowModal,
  handleCloseModal,
  show,
  publicMode,
}) => {
  const [errors, setErrors] = useState({});
  const [imagePath, setImagePath] = useState("");
  const [emergencyContact, setEmergencyContact] = useState({});
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);

  useEffect(() => {
    if (publicMode && !data.isNew) {
      setEmergencyContact(data);
    }
  }, [publicMode, data]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setSelectedData({ ...data, [name]: value });
  };

  // handle Validation
  const validateForm = () => {
    let newErrors = ValidateSchema(data, AddEmergencyContactSchema);
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return false;

    // Check if phone number is empty
    if (!data.phone_number) {
      setErrors({ ...errors, phone_number: "Phone number is required" });
      return false;
    }
    if (
      data.phone_number.length > data.country_phone.length ||
      data.phone_number.length === data.country_phone.length
    ) {
      let resultPhone = validatePhoneWithCountryCode(
        data.country_phone,
        data.phone_number
      );
      if (resultPhone) {
        setErrors({
          phone_number: resultPhone,
        });
        return false;
      }
    }
    return true;
  };

  // const handleAddUrl = async (e) => {
  //   if (!validateForm()) return;

  //   let newData = _.cloneDeep(data);
  //   newData.image = imagePath;
  //   setSelectedData(newData);
  //   handleSaveShowModal(newData);

  // };

  // const handleAddUrl = async (e) => {
  //   trackEvent("Emergency Contact", {
  //     message: "Emergency Contact Add Attempt",
  //   });

  //   e.preventDefault();
  //   if (!validateForm()) return;

  //   let newData = _.cloneDeep(data);
  //   newData.image = imagePath;
  //   setSelectedData(newData);

  //   await handleSaveShowModal(newData);

  //   trackEvent("Emergency Contact Added", {
  //     data: {
  //       ...newData,
  //       phone_number: `${newData.country_phone}${newData.phone_number}`,
  //     },
  //   });
  // };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dynamicQRCodeId = searchParams.get("dynamic_qr_code");
  const handleAddUrl = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    let newData = _.cloneDeep(data);
    newData.image = imagePath;
    setSelectedData(newData);

    await handleSaveShowModal(newData);
  };

  useEffect(() => {
    setImagePath(data?.image);
  }, [data.image]);

  const handleVcfFile = async () => {
    // setLoading(true);
    let { status, message, data } = await post(
      EMERGENCY_CONTACT_VCF_FILE_URL + `/${emergencyContact.uuid}`,
      emergencyContact,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      const link = document.createElement("a");
      link.download = "temp.vcf";
      link.href = data.url;
      link.click();
    } else {
      showToast(status, message);
    }
    // setLoading(false);
  };

  // const handleTracking = (eventName, payload = {}) => {
  //   trackEvent(eventName, {
  //     message: eventName,
  //     ...payload,
  //   });
  // };

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          setImagePath("");
          handleCloseModal();
          setErrors({});
          setEmergencyContact({});
        }}
        className="customModal square-modal"
        size="sm"
      >
        <Modal.Header className="modalHeader d-flex justify-content-between">
          <span className="modalHeading">
            {publicMode ? "View" : data?.isNew ? "Add" : "Edit "} Emergency
            Contact
          </span>
          <div className="modalGradientCircle"></div>
          <MdClose
            onClick={() => {
              setImagePath("");
              handleCloseModal();
              setErrors({});
              setEmergencyContact({});
            }}
            className="modalCloseBtn"
          />
        </Modal.Header>
        {loading ? (
          <SecondLoader />
        ) : (
          <>
            {/* <Modal.Body>
              <div className="w-full px-4 pb-2">
                <div className="flex justify-center items-center mb-4">
                  <ImageUpload
                    imageLink={true}
                    imageUrl={data.image}
                    imageType="emergency_contact"
                    setPath={setImagePath}
                    width="120px"
                    height="120px"
                    dummyImage={pictureicon}
                  />
                </div>

                <div className="mb-3">
                  <FormInput
                    type="text"
                    label="First Name"
                    placeholder="Enter first name"
                    name="first_name"
                    value={data.first_name}
                    onChange={handleChange}
                    error={errors?.first_name}
                    readOnly={publicMode}
                  />
                </div>

                <div className="mb-3">
                  <FormInput
                    type="text"
                    label="Last Name"
                    placeholder="Enter last name"
                    name="last_name"
                    value={data.last_name}
                    onChange={handleChange}
                    error={errors?.last_name}
                    readOnly={publicMode}
                  />
                </div>

                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number
                  </label>
                  {publicMode ? (
                    <a href={`tel:+${data.country_phone}${data.phone_number}`}>
                      <PhoneInput
                        country={"us"}
                        defaultCountry="us"
                        value={`${data.country_phone} ${data.phone_number}`}
                        inputStyle={{
                          border: "2px solid #DAE9F4",
                          width: "100%",
                          cursor: "pointer",
                        }}
                        inputClass="phoneNumberInput"
                        inputProps={{ readOnly: true }}
                        disableDropdown
                      />
                    </a>
                  ) : (
                    <PhoneInput
                      country={"us"}
                      enableSearch
                      countryCodeEditable={false}
                      inputClass={`w-full ${
                        errors.phone_number
                          ? "errorInput border-red-500"
                          : "phoneNumberInput"
                      }`}
                      value={data.phone_number}
                      onChange={(value, country) => {
                        setSelectedData({
                          ...data,
                          phone_number: value,
                          country_phone: `+${country.dialCode}`,
                        });
                      }}
                    />
                  )}
                  {errors?.phone_number && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.phone_number}
                    </p>
                  )}
                </div>

                <div className="mb-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Description
                  </label>
                  <textarea
                    name="description"
                    rows="4"
                    readOnly={publicMode}
                    value={data.description}
                    placeholder="Enter Description"
                    onChange={handleChange}
                    className={`w-full rounded border ${
                      errors?.description ? "border-red-500" : "border-gray-300"
                    } p-2 text-sm resize-none`}
                  />
                  {errors?.description && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.description}
                    </p>
                  )}
                </div>
              </div>
            </Modal.Body> */}

            <Modal.Body>
              <div className="px-4 pb-3">
                <div className="d-flex justify-content-center mb-4">
                  <ImageUpload
                    imageLink={true}
                    imageUrl={data.image}
                    imageType="emergency_contact"
                    setPath={setImagePath}
                    width="120px"
                    height="120px"
                    dummyImage={pictureicon}
                  />
                </div>

                <Form.Group className="form-group mb-3" controlId="firstName">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter first name"
                    name="first_name"
                    value={data.first_name}
                    onChange={handleChange}
                    isInvalid={!!errors?.first_name}
                    readOnly={publicMode}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.first_name}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="form-group mb-3" controlId="lastName">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter last name"
                    name="last_name"
                    value={data.last_name}
                    onChange={handleChange}
                    isInvalid={!!errors?.last_name}
                    readOnly={publicMode}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.last_name}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="form-group mb-3" controlId="phoneNumber">
                  <Form.Label>Phone Number</Form.Label>
                  {publicMode ? (
                    <a href={`tel:+${data.country_phone}${data.phone_number}`}>
                      <PhoneInput
                        country={"us"}
                        defaultCountry="us"
                        value={`${data.country_phone} ${data.phone_number}`}
                        inputStyle={{
                          border: "2px solid #DAE9F4",
                          width: "100%",
                          cursor: "pointer",
                        }}
                        inputClass="phoneNumberInput"
                        inputProps={{ readOnly: true }}
                        disableDropdown
                      />
                    </a>
                  ) : (
                    <PhoneInput
                      country={"us"}
                      enableSearch
                      countryCodeEditable={false}
                      inputClass={`w-100 ${
                        errors.phone_number ? "is-invalid" : "phoneNumberInput"
                      }`}
                      value={data.phone_number}
                      onChange={(value, country) => {
                        setSelectedData({
                          ...data,
                          phone_number: value,
                          country_phone: `+${country.dialCode}`,
                        });
                      }}
                    />
                  )}
                  {errors?.phone_number && (
                    <div className="invalid-feedback d-block">
                      {errors.phone_number}
                    </div>
                  )}
                </Form.Group>

                <Form.Group className="form-group mb-3" controlId="description">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="description"
                    value={data.description}
                    placeholder="Enter Description"
                    onChange={handleChange}
                    isInvalid={!!errors?.description}
                    readOnly={publicMode}
                    className="resize-none"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.description}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </Modal.Body>

            <Modal.Footer
              style={{ justifyContent: publicMode ? "center" : "flex-end" }}
            >
              {publicMode ? (
                <div className="text-center savePhonebookBtnWrapper">
                  <button onClick={handleVcfFile}>
                    <span>
                      <img src={contacticon} alt="" />
                    </span>
                    Save Contact
                  </button>
                </div>
              ) : (
                <div className="btnWrapper">
                  <Button
                    type="button"
                    onClick={() => {
                      setImagePath("");
                      handleCloseModal();
                      setErrors({});
                    }}
                    variant="outline-primary"
                    className="cancelBtn mx-3"
                  >
                    Cancel
                  </Button>

                  <Button
                    type="button"
                    onClick={handleAddUrl}
                    // onClick={()=>{
                    //   handleAddUrl();

                    // }}
                    className="saveBtn"
                  >
                    Save
                  </Button>
                </div>
              )}
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default EmergencyAddEditModal;
